if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('#list_wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const selectedValue = event.currentTarget.dataset.value;
        this.elements.input.value = selectedValue;

        try {
          window.localStorage.setItem('localisationPopup', 'true');
          this.setCookie('localisationPopup', 'true', 365);

          const inputName = this.elements.input && this.elements.input.getAttribute('name');
          if (inputName === 'country_code' && selectedValue) {
            window.localStorage.setItem('localisationCountry', selectedValue);
            this.setCookie('localisationCountry', selectedValue, 365);
            try {
              window.sessionStorage.setItem('localisationPendingCountry', selectedValue);
              window.sessionStorage.setItem('localisationUserOverride', 'true');
            } catch (e) {}
          }
        } catch (e) {}

        if (form) {
          if (this._submitting) return;
          this._submitting = true;
          form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }

      setCookie(name, value, days) {
        try {
          const date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          const expires = '; expires=' + date.toUTCString();
          const domain = location.hostname.replace(/^www\./, '');
          document.cookie = `${name}=${encodeURIComponent(value || '')}${expires}; path=/; domain=.${domain}`;
        } catch (e) {}
      }
    }
  );
}
